/**
 * Update Klarna payment by refereshing widget.
 */
class KlarnaMessaging extends HTMLElement {
	constructor() {
		super();
		const element = this.querySelector('[js-klarna-dynamic-price="klarnaPlacement"]')

		if (!element) {
      return
		}

    const cartTotalPrice = this.dataset.cartTotalPrice
    element.setAttribute("data-purchase-amount", cartTotalPrice)
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
	}
}

customElements.define('klarna-messaging', KlarnaMessaging);
